import { render, staticRenderFns } from "./auditgoods.vue?vue&type=template&id=08fab240&scoped=true"
import script from "./auditgoods.vue?vue&type=script&lang=js"
export * from "./auditgoods.vue?vue&type=script&lang=js"
import style0 from "./auditgoods.vue?vue&type=style&index=0&id=08fab240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fab240",
  null
  
)

export default component.exports